import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

class ProductStockStatus extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateStockStatus);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateStockStatus);
  }

  /**
   * Updates the stock status when the selected product variant changes.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateStockStatus = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.detail.data.productId !== this.dataset.productId) {
      return;
    }

    const newStockStatus = event.detail.data.html.querySelector(
      `product-stock-status[data-block-id="${this.dataset.blockId}"]`
    );

    if (!newStockStatus) return;

    morph(this, newStockStatus, { childrenOnly: true });
  };
}

if (!customElements.get('product-stock-status')) {
  customElements.define('product-stock-status', ProductStockStatus);
}
